import { connect } from 'react-redux'

import {
  operationFetchMonthlyInvoiceOrders,
  operationRunKlarnaMonthlyInvoiceOperation,
  operationRunKlarnaOrderOperation,
  operationExpandMonthlyInvoiceOrderForFilter,
  operationExpandMonthlyInvoiceForFilter,
} from '../../duck/operations'
import selectors from '../../duck/selectors'
import MonthlyInvoiceComponent from './MonthlyInvoice.component'

const mapStateToProps = (state, { invoiceId, filterName }): any => {
  const invoice = selectors.getMonthlyInvoiceById(invoiceId, state)
  const isInvoiceOrdersLoaded = selectors.getIsMonthlyInvoiceOrdersLoaded(invoiceId, state)
  const isMonthlyInvoiceOrdersLoading = selectors.getIsMonthlyInvoiceOrdersLoading(invoiceId, state)
  const isLoadingMore = selectors.getIsMonthlyInvoiceOrdersLoading(invoiceId, state)
  const invoiceOrderIds = selectors.getMonthlyInvoiceOrderIds(invoiceId, state)
  const expandedOrderId = selectors.getMonthlyInvoiceExpandedOrderForFilter(filterName, state)
  const shouldShowLoadMoreButton = selectors.getShouldShowMonthlyInvoiceOrdersLoadMoreButton(
    invoiceId,
    state,
  )
  const loadingOrderId = selectors.getLoadingOrderId(state)
  const expandedMonthlyInvoiceId = selectors.getMonthlyInvoiceExpandedForFilter(filterName, state)

  return {
    invoice,
    isInvoiceOrdersLoaded,
    isMonthlyInvoiceOrdersLoading,
    invoiceOrderIds,
    shouldShowLoadMoreButton,
    loadingOrderId,
    isLoadingMore,
    expandedOrderId,
    expandedMonthlyInvoiceId,
  }
}

const mapDispatchToProps = (dispatch, { filterName }): any => {
  const expandMonthlyInvoiceOrderById = (orderId): any =>
    dispatch(operationExpandMonthlyInvoiceOrderForFilter(filterName, orderId))

  const expandMonthlyInvoiceById = (monthlyInvoiceId): any =>
    dispatch(operationExpandMonthlyInvoiceForFilter(filterName, monthlyInvoiceId))

  const loadMoreOrders = (invoiceId): any => dispatch(operationFetchMonthlyInvoiceOrders(invoiceId))
  const fetchMonthlyInvoiceOrders = (collectionId): any =>
    dispatch(operationFetchMonthlyInvoiceOrders(collectionId))
  const runKlarnaMonthlyInvoiceOperation = (token, invoiceId): any =>
    dispatch(operationRunKlarnaMonthlyInvoiceOperation(token, invoiceId))
  const runKlarnaOrderOperation = (token, orderId): any =>
    dispatch(operationRunKlarnaOrderOperation(token, orderId))

  return {
    expandMonthlyInvoiceOrderById,
    expandMonthlyInvoiceById,
    loadMoreOrders,
    fetchMonthlyInvoiceOrders,
    runKlarnaMonthlyInvoiceOperation,
    runKlarnaOrderOperation,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyInvoiceComponent)
